import React from 'react';

interface ImgBoxProperty {
	className?: string;
	backgroundImgUrl: string;
	children?: React.ReactNode;
}

/**
 * 含背景圖的div, 中間可放 children 當作一般 div 使用, 
 * 可傳入 className 客製化, 跟普通 div 一樣, 記得要額外給寬高才會顯示背景圖
 */
const ImgBox: React.FC<ImgBoxProperty> = ({ className, backgroundImgUrl, children }) => (
	<div
		className={className}
		style={{
			backgroundImage: `url(${backgroundImgUrl})`,
			backgroundSize: 'cover',
		}}
	>
		{children}
	</div>
);

export default ImgBox;